import { ReactNode } from 'react'
import KpiCell from 'workflow/common/kpiCell'

import { ResultColumn } from '../useWinnerVariantInfo'

type Props = {
  results: ResultColumn[]
  children: ReactNode
}

const Results = ({ results, children }: Props) => {
  return (
    <>
      {results.map(({ key, title, value }) => {
        return (
          <KpiCell
            key={key}
            title={title.replace('Final ', '')}
            value={value!}
            valueClassName="text-maroon-400"
          />
        )
      })}
      {children}
    </>
  )
}

export default Results
